import React, { useState, useEffect, useCallback, useReducer, useMemo, useRef } from 'react';
import { path, defaultTo } from 'ramda';
import storage from 'local-storage-fallback';
import _connect from '../_helpers/new_connect';
import axios from 'axios';
import { Amplify, Auth, Hub } from 'aws-amplify';
import { auth_config } from '~/_helpers/commons';
import { encryptAES, decryptAES } from '~/_helpers/commons';
import { setLogoutHandler, clearLogoutHandler } from '../_helpers/authBridge';

Amplify.configure({
  /*
  Auth: auth_config,
  Storage: {
    AWSS3: {
        bucket: 'dotsprojectdev-storage-fcc018c4110821-dev', //REQUIRED -  Amazon S3 bucket
        region: 'us-east-2', //OPTIONAL -  Amazon service region
      }
  }
  */
});
//https://dotsprojectdev-storage-fcc018c4110821-dev.s3.us-east-2.amazonaws.com
export const AuthContext = React.createContext({});

export const AuthProvider = ({ children }) => {

    const [ isAuth, setIsAuth ] = useState(null);
    const [ authToken, setAuthToken ] = useState(null);
    const [ userData, setUserData ] = useState(null);
    const [ userAmplify, setUserAmplify ] = useState(null);
    const [ isAuthLoading, setIsAuthLoading ] = useState(null);
    const [ isMfaLoading, setIsMfaLoading ] = useState(null);
    const [ activeRoute, setActiveRoute ] = useState('');
    const [ loginError, setLoginError ] = useState(false);
    const [ tttcAgree, setTttcAgree ] = useState(null);
    const [ newPasswordRequired, setNewPasswordRequired ] = useState({});
    const [ showMfa, setShowMfa ] = useState(false);
    const [ showLogin, setShowLogin ] = useState(true);//false
    const [ codeDeliveryDestination, setCodeDeliveryDestination ] = useState("");
    const [ mfaData, setMfaData ] = useState({});
    const [ session, setSession ] = useState("");
    const [ username, setUsername ] = useState("");
    

  /* INI OLD LIGIN */
  
  const signIn = useCallback(async (username, password) => {
    /*
      try {
          setLoginError(false);
          setIsAuthLoading(true);
          const tttc_agree = true;
          const user = await Auth.signIn("sp_" + username, password);//Auth.signIn(username, password);

          //const user = await Auth.signIn("dots_" + username, password)
          //const user = await Auth.signIn("sp_" + username, password)
          if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
              setNewPasswordRequired(user);
              return null;
              //isContinueReg(user)
          } else {
            //await checkUser()
          }
          setUserAmplify(user);
          get_terms_and_conditions(user);

      } catch (error) {
          setLoginError(true);
          setIsAuthLoading(false);
          return {success: false, message: error.message};
      }
    */
  }, []);

  /* END */

  const signInEncrypted = useCallback(async (username, password) => {

    setUsername(encryptAES('sp_'+username));
    setLoginError(false);
    setIsAuthLoading(true);
    const tttc_agree = true;

    axios.post(process.env.REACT_APP_BASE_URL+'/user_login_encrypted', {'user_login': encryptAES('sp_'+username), 'password': encryptAES(password)}, {
      headers: {
        //'user_login': encryptAES('sp_'+username),
        //'password': encryptAES(password),
      }
    })
    .then(response => {
      
      setSession(encryptAES(response.data.user.session));

      switch (response.data.status) {
          case 1: //Login correcto

            
            setIsMfaLoading(false);
            storage.setItem('protagonistas_u', encryptAES('sp_'+username));
            storage.setItem('protagonistas_token', response.data.user.IdToken);
            storage.setItem('protagonistas_rtoken', response.data.user.RefreshToken)

            //setCode("");
            //setCountdown(60);
            setShowMfa(false);
            setShowLogin(true);
            //setErrorFields({code: false});

            get_terms_and_conditions(response.data);
            

              /*
              await AuthTokenStorage.setTokens(responseLogin.user.IdToken, responseLogin.user.RefreshToken)
              // setTimeoutLimit(LIMIT_TIMEOUT_LOGIN_5_SECONDS)
              if (isSwitchEnabled) {
                  const dataUserSave = {
                      username: userLogin, // login
                      password: passwordLogin, // login
                      biometricsActive: isSwitchEnabled,
                      avatar: '',
                      email: '',
                      user_name: '',
                      isVisible: false,
                  }
                  await saveDataBiometrics(dataUserSave)
              }
              setAuthStatus('loggedIn')
              //await checkUser()
              */
              break
          case 2: //Cambio de contraseña requerido
              setMfaData({username: username})
              setNewPasswordRequired(response.data.user);
              //isContinueReg(responseLogin.user)
              //  if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {

              //  } else {
              //      try {
              //          await checkUser()

              //      } catch (error) {
              //          throw new Error(error)
              //      }
              //  }
              break
          case 3: //SMS_MFA
              setCodeDeliveryDestination(response.data.user.user_login.CODE_DELIVERY_DESTINATION)
              response.data.username = username;
              response.data.password = encryptAES(password);
;
              setMfaData(response.data)
              setShowLogin(false);
              setShowMfa(true);
              // const sessionEncrypted = AuthTokenStorage.encryptData(responseLogin.user.session)
              // const typeEncrypted = AuthTokenStorage.encryptData(responseLogin.type)

              // const codeDelivery = responseLogin.user.CODE_DELIVERY_DESTINATION


              // openMFAModal(userNameEncrypted, sessionEncrypted, typeEncrypted, responseLogin.type, codeDelivery, passwordParamEncrypted)
              break
          default: //-1 [Error]
            /*
              const { title, desc } = mapErrorsHandleLogin(error)

              setErrorModal({
                  status: true,
                  title: title,
                  desc: desc,
              })
                  */
              break
      }

      setIsAuthLoading(false);

      
      //storage.setItem('protagonistas_token', response.data.user.IdToken);
      //storage.setItem('protagonistas_rtoken', response.data.user.RefreshToken)
      //get_terms_and_conditions(response.data)
    })
    .catch(error => {
      setLoginError(true);
      setIsAuthLoading(false);
      console.error(error);
    });
  }, []);

  const respondToMfaChallenge = useCallback(async (code, mfaData, session, close = true) => {
    setIsMfaLoading(true);
    const requestURL = `${process.env.REACT_APP_BASE_URL}/respond_to_mfa_challenge`;
      const params = {
        username: encryptAES('sp_'+mfaData.username),
        session: session,//encryptAES(mfaData.user.session),
        mfa_code: encryptAES(code),
        type: encryptAES(mfaData.type)
      };
      
      const config = {
          headers: {
              //'Content-Type': 'application/x-www-form-urlencoded'
          }
      }

      const result = await _connect.post(requestURL, params, config);

      setIsMfaLoading(false);
      storage.setItem('protagonistas_u', encryptAES('sp_'+mfaData.username));
      storage.setItem('protagonistas_token', result.data.user.IdToken);
      storage.setItem('protagonistas_rtoken', result.data.user.RefreshToken)

      if(close){
        setNewPasswordRequired({});
        setShowMfa(false);
        setShowLogin(true);
        get_terms_and_conditions(result.data)
      }

      return result;

  }, []);
  
  const resendMfaCode = useCallback(async (mfaData) => {
    const requestURL = `${process.env.REACT_APP_BASE_URL}/resend_mfa_code`;
      const params = {
        username: encryptAES('sp_'+mfaData.username),
        password: mfaData.password,
        method: encryptAES(mfaData.type)
      };
      
      const config = {
          headers: {
              //'Content-Type': 'application/x-www-form-urlencoded'
          }
      }

      const result = await _connect.post(requestURL, params, config);

      setSession(encryptAES(result.data.session));

      const mfaDataUpdate = {...mfaData};
      mfaDataUpdate.user.session = result.data.session;
      setMfaData(mfaDataUpdate);

      return result;
  }, []);
  
  /*
  const signInEncrypted = useCallback(async (username, password) => {
    try {
      const params = new URLSearchParams();

      const config = {
        headers: {
          'user_login': encryptAES('sp_'+username, 'YcVG5zXgbeOP08zM8MoUAbd9gZn9fj'),
          'password': encryptAES(password, 'YcVG5zXgbeOP08zM8MoUAbd9gZn9fj'),
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      const response = await _connect.post(`${process.env.REACT_APP_URLGATEWAY}/user_login_encrypted`, params, config);

    } catch (e) {
      return false;
    }
  }, []);
  */
  /*
  const encryptAES = (data) => {
    const ciphertext = CryptoJS.AES.encrypt(data, process.env.REACT_APP_ENKEY).toString();
    return ciphertext;
  };

  const decryptAES = (data) => {
    const decrypted = CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENKEY);
    return decrypted;
  };
  */

    const signOut = useCallback(async () => {
        setIsAuthLoading(true);
        try {

            await Auth.signOut();
            setIsAuthLoading(false);
            setIsAuth(false);
            storage.removeItem('protagonistas_token');

        } catch (error) {

        }
    }, []);

    /*
    const get_terms_and_conditions = useCallback(async (user) => {
      alert("asd");
      const requestURL = `${process.env.REACT_APP_BASE_URL}/get_terms_and_conditions`;
  
      const result = await _connect.get(`${requestURL}`, {
          //headers: {},
      });
      
      try {
  
        const requestURL = `${process.env.REACT_APP_BASE_URL}/get_terms_and_conditions`;
  
        const result = await _connect.get(`${requestURL}`, {
            headers: {},
        });
  
      } catch (error) {
        //logout();
        return false;
  
      }
      
  
    }, []);
    */
    
    const get_terms_and_conditions = (data) => {
      
      const requestURL = `${process.env.REACT_APP_BASE_URL}/get_terms_and_conditions`;
      const response = _connect.get(`${requestURL}`);

      response.then(res => {
        const tttc_agree_status = false;
        setTttcAgree(tttc_agree_status);

        storage.setItem('protagonistas_tttc_agree', tttc_agree_status ? true : false);
        //storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
        //storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
        setNewPasswordRequired({});
        setShowMfa(false);
        setShowLogin(true);

        setIsAuthLoading(false);
        setIsAuth(true);


      }).catch(err => {
        const tttc_agree_status = true;
        setTttcAgree(tttc_agree_status);

        storage.setItem('protagonistas_tttc_agree', tttc_agree_status ? true : false);
        //storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
        //storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
        setNewPasswordRequired({});
        setShowMfa(false);
        setShowLogin(true);
        setIsAuthLoading(false);
        setIsAuth(true);
      });

      // const tttc_agree_status = true;//!path(['data', 'single', 'status'], res);
      // setTttcAgree(tttc_agree_status);
      // storage.setItem('protagonistas_tttc_agree', tttc_agree_status);
      // storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
      // storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
      // setIsAuthLoading(false);
      // setIsAuth(true);
      

      /*
      const requestURL = `${process.env.REACT_APP_BASE_URL}/get_terms_and_conditions`;
      const response = _connect.get(`${requestURL}`);

      response.then(res => {
        
        const tttc_agree_status = false;//path(['data', 'status'], res);//true;//!path(['data', 'single', 'status'], res);
        setTttcAgree(tttc_agree_status);
        //setTttcAgree(tttc_agree_status ? true : false);
        storage.setItem('protagonistas_tttc_agree', tttc_agree_status ? true : false);
        storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
        storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
        setIsAuthLoading(false);
        setIsAuth(true);
        
      }).catch(err => {

        const tttc_agree_status = true;//path(['data', 'status'], res);//true;//!path(['data', 'single', 'status'], res);
        setTttcAgree(tttc_agree_status);
        //setTttcAgree(tttc_agree_status ? true : false);
        storage.setItem('protagonistas_tttc_agree', tttc_agree_status ? true : false);
        storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
        storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
        setIsAuthLoading(false);
        setIsAuth(true);

        //setHaveResponseError(true);
        //setHaveResponseErrorMessage(err.message);

      });
      */
     

    };
    /*
    const get_terms_and_conditions = (user) => {
      
      // const tttc_agree_status = true;//!path(['data', 'single', 'status'], res);
      // setTttcAgree(tttc_agree_status);
      // storage.setItem('protagonistas_tttc_agree', tttc_agree_status);
      // storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
      // storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
      // setIsAuthLoading(false);
      // setIsAuth(true);
      

      
      const requestURL = `${process.env.REACT_APP_BASE_URL}/get_terms_and_conditions`;
      const response = _connect.get(`${requestURL}`);

      response.then(res => {
        
        const tttc_agree_status = false;//path(['data', 'status'], res);//true;//!path(['data', 'single', 'status'], res);
        setTttcAgree(tttc_agree_status);
        //setTttcAgree(tttc_agree_status ? true : false);
        storage.setItem('protagonistas_tttc_agree', tttc_agree_status ? true : false);
        storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
        storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
        setIsAuthLoading(false);
        setIsAuth(true);
        
      }).catch(err => {

        const tttc_agree_status = true;//path(['data', 'status'], res);//true;//!path(['data', 'single', 'status'], res);
        setTttcAgree(tttc_agree_status);
        //setTttcAgree(tttc_agree_status ? true : false);
        storage.setItem('protagonistas_tttc_agree', tttc_agree_status ? true : false);
        storage.setItem('protagonistas_token', user.signInUserSession.idToken.jwtToken);
        storage.setItem('protagonistas_access_token', user.signInUserSession.accessToken.jwtToken);
        setIsAuthLoading(false);
        setIsAuth(true);

        //setHaveResponseError(true);
        //setHaveResponseErrorMessage(err.message);

      });
      

    };
    */


    const setAgreeTerms = async (payload) => {

      const requestURL = `${process.env.REACT_APP_BASE_URL}/accept_terms_and_conditions`;//oneapp/users/tttc_agree
      const params = {};//new URLSearchParams()
      /*
      if(Object.keys(payload).length){
          Object.keys(payload).map(function(key) {
              params.append(key, payload[key]);
          })
      }
      */
      const config = {
          headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
          }
      }
      const result = await _connect.post(requestURL, params, config);
      return result;
    }

    // const setAgreeTerms = async () => {

    //   const requestURL = `${process.env.REACT_APP_API_SERVER}/users/tttc_agree`;

    //   try {

    //     const token = storage.getItem('protagonistas_token');

    //     const params = new URLSearchParams()
    //           params.append('token', token);

    //     const config = {
    //       headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //       }
    //     }

    //     const result = await connect.post(requestURL, params, config);

    //     return result;

    //   } catch (error) {
    //   }




    // }

    

    useEffect(() => {



      const actualToken = defaultTo('', storage.getItem('protagonistas_token'));
      setAuthToken(actualToken);
      if(actualToken.length > 0){
        setIsAuth(true);
        setTttcAgree(storage.getItem('protagonistas_tttc_agree'));
      }
    }, []);

    useEffect(() => {

      if (!authToken) {
        //updateUserLoginData({ ...loggedOutUser });
      } else {
        //updateToken(authToken);
        //fetchData();
      }
        /*
        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('utm_source') === 'mobile_app') {
        setIsMobileApp(true);
        }
        */

        //setAuthToken(defaultTo('', storage.getItem('ie_access_token')));

    }, [authToken]);

    const login = useCallback(

        async (username, password) => {
          setIsAuthLoading(true);
          setLoginError(false);

          try {
            const payload = {
              password: password,
              e_mail: username,
            };

            const params = new URLSearchParams()
                  params.append('password', password)
                  params.append('e_mail', username)
                  params.append('id_client', '6139135c3814168c11fa57ee')
                  params.append('firebase_token', '')
                  params.append('version_name', '1.0')
                  params.append('version_code', 'web')

                  const config = {
                    headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                    }
                  }

              _connect.post(`${process.env.REACT_APP_API_SERVER}/login`, params, config).then(response => {
                const status = path(['data', 'status'], response);
                if(status === 1){
                  const accessToken = path(['data', 'single', 'token'], response);
                  const tttc_agree = path(['data', 'single', 'tttc_agree'], response);
                  const embajadores = (path(['data', 'single', 'flag_user'], response)) == 3 ? true :  false;

                  setTttcAgree(tttc_agree);
                  setIsAuth(true);
                  storage.setItem('protagonistas_tttc_agree', tttc_agree);
                  storage.setItem('protagonistas_token', accessToken);
                  storage.setItem('show_embajadores', embajadores);
                  storage.setItem('popup_shellbox2_puntosextra', false);

                  setActiveRoute('');
                }else{
                  setLoginError(true);
                }

                setIsAuthLoading(false);

              })

            return true;

        } catch (e) {


        }

        return false;

        },[],
    );

    useEffect(() => {
      setLogoutHandler(logout);

      return () => {
        clearLogoutHandler();
      };
    }, [logout]);

    const logout = useCallback(async () => {
      storage.clear();
      setAuthToken(null);
      setIsAuth(false);
    }, [authToken]);

    const recupero = useCallback(async (email, dni) => {
    }, []);


    const getPhoneToValidate = async (dni) => {

      try {

        const response = await _connect.get(`${process.env.REACT_APP_API_SERVER}/users/get_phone_to_validated`, {
          headers: {
            'employee_id': dni,
            'id_client': '6139135c3814168c11fa57ee',
          },
        });

        const response_parse = path(['data', 'single'], response);

        return response_parse;

        /*
        if(posts && posts.length){
          setPosts(prevState => [...prevState, ...normalized]);
        }else{
          setPosts(normalized);
        }
        */


      } catch (error) {
        //alert("logout");
        //setLoading(false);
        //console.error(error);
      }
    };

    const changePasswordRecover = async (payload) => {

      const requestURL = `${process.env.REACT_APP_API_SERVER}/users/change_password_recover`;

      try {

        const token = storage.getItem('protagonistas_token');

        const params = new URLSearchParams()
              params.append('employee_id', payload.dni);
              params.append('new_password', payload.new_password);
              params.append('re_password', payload.re_password);
              params.append('id_client', '6139135c3814168c11fa57ee');

        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }

        const result = await _connect.post(requestURL, params, config);

        return result;

      } catch (error) {
        //alert("logout");
        //logout();
        //console.error(error);
      }

    }

  const updateUserPasswordAdmin = async (username, password) => {

    const requestURL = `${process.env.REACT_APP_BASE_URL}/update_user_password_admin`;
      
    let params = {
      username: username,
      password: encryptAES(password),
    }
    const config = {
      headers: {
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    }


    const result = await axios.post(requestURL, params, config);
    return result;

    /*
      try {

        let params = {
          username: username,
          password: encryptAES(password),
        }
        const config = {
          headers: {
            //'Content-Type': 'application/x-www-form-urlencoded'
          }
        }


        const result = await _connect.post(requestURL, params, config);
        return result;

      } catch (error) {
        //alert("logout");
        //logout();
        //console.error(error);
      }
      */

  }
  
  const verifyUserEmailPhone = async (username, updatedAttributes, code, refreshToken) => {
    //return null;
    const requestURL = `${process.env.REACT_APP_BASE_URL}/verify_user_email_phone`;

    let attributes = {};

    if('email' in updatedAttributes){
      attributes.email = updatedAttributes.email; 
    }
    if('phone' in updatedAttributes){
      attributes.phone_number = updatedAttributes.phone;
    }

    let params = {
      username: username,
      code: encryptAES(code),
      refreshToken: encryptAES(refreshToken),
      attributes: encryptAES(JSON.stringify(attributes)),
    }
    
    const config = {
      headers: {
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    const result = await axios.post(requestURL, params, config);
    return result;

  }

  const updateUserAttributesAdmin = async (username, updatedAttributes) => {

    const requestURL = `${process.env.REACT_APP_BASE_URL}/update_user_attributes_admin`;

    let attributes = {
      family_name: updatedAttributes.family_name,
      birthdate: updatedAttributes.birthdate,
      gender: updatedAttributes.gender,
      phone_number: updatedAttributes.phone_number,
      email: updatedAttributes.email,
    }
    let params = {
      username: username,
      attributes: encryptAES(JSON.stringify(attributes)),
    }
    
    // updatedAttributes.name = firstName
    //   updatedAttributes.family_name = lastName
    //   updatedAttributes.birthdate = birthDateYear + "-" + birthDateMonth + "-" + birthDateDay;
    //   updatedAttributes.gender = gender
    //   updatedAttributes.phone_number = phone.length ? '+549' + phone : ''
    //   updatedAttributes.email = email.length ? email : ''

    // const params = new URLSearchParams()
    //       params.append('username', username);
    //       params.append('family_name', payload.family_name);
    //       params.append('birthdate', payload.birthdate);
    //       params.append('gender', payload.gender);
    //       params.append('phone_number', payload.phone_number);
    //       params.append('email', payload.email);
    
    const config = {
      headers: {
        'Authorization': storage.getItem('protagonistas_token'),
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    const result = await axios.post(requestURL, params, config);
    return result;
    
      /*
      try {

        //const token = storage.getItem('protagonistas_token');
        
        let attributes = {
          family_name: encryptAES(updatedAttributes.family_name),
          birthdate: encryptAES(updatedAttributes.birthdate),
          gender: encryptAES(updatedAttributes.gender),
          phone_number: encryptAES(updatedAttributes.phone_number),
          email: encryptAES(updatedAttributes.email),
        }
        let params = {
          username: username,
          attributes: attributes,
        }
        
        // updatedAttributes.name = firstName
        //   updatedAttributes.family_name = lastName
        //   updatedAttributes.birthdate = birthDateYear + "-" + birthDateMonth + "-" + birthDateDay;
        //   updatedAttributes.gender = gender
        //   updatedAttributes.phone_number = phone.length ? '+549' + phone : ''
        //   updatedAttributes.email = email.length ? email : ''

        // const params = new URLSearchParams()
        //       params.append('username', username);
        //       params.append('family_name', payload.family_name);
        //       params.append('birthdate', payload.birthdate);
        //       params.append('gender', payload.gender);
        //       params.append('phone_number', payload.phone_number);
        //       params.append('email', payload.email);
        
        const config = {
          headers: {
            //'Content-Type': 'application/x-www-form-urlencoded'
          }
        }

        const result = await _connect.post(requestURL, params, config);

        return result;

      } catch (error) {
        //alert("logout");
        //logout();
        //console.error(error);
      }
      */

  }

  const forgotPassword = async (username) => {
    console.log("🍟", username);
    
    const requestURL = `${process.env.REACT_APP_BASE_URL}/forgot_password`;
    
    let params = {'user_login': encryptAES("sp_"+username)}
    
    const config = {
      headers: {
        //'user_login': encryptAES("sp_"+username),
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    const result = await axios.post(requestURL, params, config);
    return result;

  }

  const confirmResetPassword = async (username, password, code) => {
    console.log("🍟🍟", username, password, code);
    //return null
    const requestURL = `${process.env.REACT_APP_BASE_URL}/confirm_reset_password`;
    
    let params = {'user_login': encryptAES("sp_"+username),
                  'new_password': encryptAES(password),
                  'code': code
    }
    
    const config = {
      headers: {
        //'user_login': encryptAES("sp_"+username),
        //'Content-Type': 'application/x-www-form-urlencoded'
      }
    }

    const result = await axios.post(requestURL, params, config);
    return result;

  }
  


  return (
    <AuthContext.Provider
      value={{
        Auth,
        isAuth,
        userData,
        isAuthLoading,
        setIsAuthLoading,
        isMfaLoading, 
        setIsMfaLoading,
        login,
        logout,
        activeRoute,
        setActiveRoute,
        loginError,
        setLoginError,
        getPhoneToValidate,
        changePasswordRecover,
        setAgreeTerms,
        tttcAgree, setTttcAgree,
        signIn, signOut, signInEncrypted,
        newPasswordRequired, 
        setNewPasswordRequired,
        showMfa, setShowMfa,
        showLogin, setShowLogin,
        codeDeliveryDestination,
        respondToMfaChallenge,
        resendMfaCode,
        mfaData,
        session,
        username, setUsername,
        updateUserPasswordAdmin,
        updateUserAttributesAdmin,
        verifyUserEmailPhone,
        encryptAES, decryptAES,
        get_terms_and_conditions,
        forgotPassword,
        confirmResetPassword
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
